import * as React from 'react';
import { FC, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { useSelector } from 'react-redux';
import { getWallets, resetWallet, setToastMessage, useAppDispatch, Wallet, walletSelector } from '../../state';
import { Column } from 'primereact/column';
import { useAuth } from 'react-oidc-context';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

export const WalletList: FC = () => {
    const dispatch = useAppDispatch();
    let auth = useAuth();

    useEffect(() => {
        dispatch(getWallets({jwtToken: auth.user?.access_token}));
    }, [auth.user]);

    let walletState = useSelector(walletSelector);

    function confirmDeleteService(wallet: Wallet) {

        confirmDialog({
            header: 'Reset wallet',
            message: <div>Are you sure you want to reset the wallet of {wallet.displayName}? <br/><br/>
                These actions wil be excuted:<br/>
                <ul>
                    <li>All existing credentials will be deleted</li>
                    <li>All existing workflows will be deleted</li>
                    <li>All existing inbox items will be deleted</li>
                    <li>All existing history will be deleted</li>
                    <li>The wallet will be set to state: Initial</li>
                </ul>
                This action cannot be undone.</div>,
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => executeResetWallet(wallet),
            reject: () => {
            }
        });
    }

    function executeResetWallet(wallet: Wallet) {
        dispatch(resetWallet({jwtToken: auth.user?.access_token!, walletExternalKey: wallet.externalKey})).then((response) => {
            if (response.type.includes('fulfilled')) {
                dispatch(setToastMessage({message: "Wallet reset successfully"}));
            }
        });
    }


    return (
        <DataTable value={walletState.list} tableStyle={{minWidth: '50rem'}} selectionMode="single" onSelectionChange={(e) => {
            // handleSelectCredential(e.value);
        }}>
            <Column header={"Name"} body={(wallet) => wallet.displayName}></Column>
            <Column className="hidden md:table-cell" header={<div className="hidden md:table-cell">Wallet state</div>} body={(wallet) => wallet.walletState}></Column>
            <Column className="hidden md:table-cell" header={<div className="hidden md:table-cell">Number of credentials</div>} body={(wallet) => wallet.credentialsCount}></Column>
            <Column className="hidden md:table-cell" header={<div className="hidden md:table-cell">Number of workflows</div>} body={(wallet) => wallet.workflowsCount}></Column>
            <Column className="hidden md:table-cell" header={<div className="hidden md:table-cell">Number of inbox items</div>} body={(wallet) => wallet.inboxCount}></Column>
            <Column className="hidden md:table-cell" header={<div className="hidden md:table-cell">Number of history events</div>} body={(wallet) => wallet.historyCount}></Column>
            <Column className="hidden xl:table-cell" header={<div className="hidden xl:table-cell">Created at</div>} body={(wallet) => wallet.createdAt}></Column>
            <Column className="hidden xxl:table-cell" header={<div className="hidden xxl:table-cell">Created by</div>} body={(wallet) => wallet.createdBy}></Column>
            <Column header='' body={(wallet: Wallet) => <Button onClick={() => confirmDeleteService(wallet)}>Reset wallet</Button>}></Column>
        </DataTable>
    )
}
